import Layout from "@/components/Layout";
import { Center, Divider, Heading, Text, VStack } from "@chakra-ui/react";
import ExportedImage from "next-image-export-optimizer";
import { FunctionComponent } from "react";
import intuityLogo from "../res/img/intuity_logo.svg";
import synapseBanner from "../res/img/synapse-banner.png";

const Home: FunctionComponent = () => {
  return (
    <Layout>
      <Center w="full" h="full">
        <VStack
          p={8}
          rounded="md"
          bg="whiteAlpha.300"
          backdropBlur="lg"
          maxW="md"
          overflowY="auto"
          maxH="full"
          spacing={4}>
          <ExportedImage
            src={synapseBanner}
            alt="synapse banner"
            width={200}
            height={200}
          />

          <Heading fontFamily="corpoA" fontWeight="normal" textAlign="center">
            Synapse
          </Heading>
          <Text fontStyle="italic">Next-generation customer communication</Text>

          <Text
            fontSize="xl"
            textAlign="center"
            fontWeight="bold"
            w="full"
            color="white"
            p={4}
            rounded="md"
            bg="brandFull">
            <u>This is a protoype</u>
            <br />
            For testing purposes only!
          </Text>

          <Text>
            Important note: Everything sent off will be both stored in a
            database managed by Intuity Media Lab and hosted on Amazon Web
            Services in Europe. Every request is sent to servers by OpenAI
            hosted in the United States of America. Therefore, do not enter
            sensitive or classified data!
          </Text>
          <Divider />
          <VStack>
            <Text>
              Contact: Maximilian Hans{" "}
              <a
                href="mailto:hans@intuity.de"
                style={{ textDecoration: "underline" }}>
                (hans@intuity.de)
              </a>
            </Text>
            <Text>
              Created at{" "}
              <a
                href="https://www.intuity.de/"
                style={{ textDecoration: "underline" }}
                target="_blank"
                rel="noreferrer noopener">
                Intuity Media Lab
              </a>
              , 2023{" "}
            </Text>
            <ExportedImage
              style={{ color: "white", width: "80px" }}
              alt="logo intuity"
              src={intuityLogo}
            />
          </VStack>
        </VStack>
      </Center>
    </Layout>
  );
};

export default Home;
